import {apiClient, getOne, createOne, updateOne, deleteOne, getAll} from "./Api";

const MODULE = 'album';

export function getAlbum(id) {
	return getOne(MODULE, id);
}

export function getAlbumsByName(name, artist) {
	if (artist) {
		return  apiClient.get(`${MODULE}?name=${name}&fk_artist=${artist}`);
	}

	return  apiClient.get(`${MODULE}?name=${name}`);
}
